import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './login';
import Home from './home';
import Register from './register';
import ForgotPassword from './forgotpassword';
import ResetPassword from './resetpassword';
import CreateBuilder from './createbuilder';
import FrameBuilder from './frameBuilder';
import ErrorPage from './error';
import ProtectedRoute from './protectedRoute'; // 👈 import

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/resetpassword" element={<ResetPassword />} />

        {/* 👇 Protected Routes */}
        <Route
          path="/createbuilder"
          element={
            <ProtectedRoute>
              <CreateBuilder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/frameBuilder"
          element={
            <ProtectedRoute>
              <FrameBuilder />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
}

export default App;
